const API_URL = process.env.REACT_APP_AI_URL;

export async function askChoiceLink(authFetch, nodesToLink) {
  const payload = {
    nodes_to_link: nodesToLink.map(({ id, label, text_content }) => ({
      id,
      label,
      text_content,
    })),
  };

  const response = await authFetch(`${API_URL}/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('AI request failed');
  }

  return response.json();
}
